import { render, staticRenderFns } from "./EmployeeSupport.vue?vue&type=template&id=30f2c1ea&scoped=true"
import script from "./EmployeeSupport.vue?vue&type=script&lang=js"
export * from "./EmployeeSupport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f2c1ea",
  null
  
)

export default component.exports